import axios from 'axios';
import loadingAnimation from '../loading-animation.vue';
import axiosError from '../axios-error.vue';
import { delDiaPdp } from '../mixins/delDiaPdp';
import { pdp } from '../mixins/pdp';
import { Colors } from '../enums/colors';
import sizechart from '../pdp/sizechart/sizechart.vue';

export default {
  name: 'delDiaSlide',
  components: {
    loadingAnimation,
    axiosError,
    sizechart,
  },
  props: [
    'product',
    'productId',
    'abVersion',
    'accordionContent',
    'lifestyleImgs',
    'delDiaApparel',
  ],
  mixins: [delDiaPdp, pdp],
  data() {
    return {
      Colors,
      selectedVariant: {},
      refreshing: false,
      error: false,
      isSurprise: false,
      soldout: false,
      backOrder: false,
      showSizemodal: false,
      accordionContent: [],
      whyYoullLoveIt: '',
      activeDrawer: 0,
      ddProduct: {},
      eventEmitter: {},
      currentUrl: window.location.href,
    };
  },
  computed: {},
  methods: {
    urlContains(str) {
      return this.currentUrl.includes(str);
    },
    //Core cart functions
    slideToggle() {
      let ddslideClassList = document.getElementById('ddslide').classList;
      if (ddslideClassList.contains('ddslide-open')) {
        this.closeSlide();
      } else {
        this.openSlide();
      }
    },
    //used to open the side cart
    openSlide() {
      // open the cart by attaching class
      let ddslideClassList = document.getElementById('ddslide').classList;
      if (!ddslideClassList.contains('ddslide-open')) {
        document.getElementById('ddslide').classList.add('ddslide-open');
      }
      //this.featuredImage = this.product.images[0].src;
    },
    //slide the cart off screen
    closeSlide() {
      let ddslideClassList = document.getElementById('ddslide').classList;
      if (ddslideClassList.contains('ddslide-open')) {
        document.getElementById('ddslide').classList.remove('ddslide-open');
      }
      document.querySelector('.coto_header').classList.remove('cart-squish');
    },
    selectVariant(product) {
      this.selectedVariant = product;
    },
    filterPrice(price) {
      let formattedPrice = price.toString(); // just in case data is passed through as integer
      if (!formattedPrice.includes('.00')) {
        // keeps decimal places if price does not end in .00
        formattedPrice = parseFloat(formattedPrice).toFixed(2);
      } else {
        formattedPrice = parseFloat(formattedPrice).toFixed(0); // drops $.00 if price is even number
      }
      return `$${formattedPrice}`;
    },
    toggleFavorite(product) {
      if (!product.favorite) {
        product.favorite = true;
      } else {
        product.favorite = !product.favorite;
      }
      console.log(this.choiceProducts);
    },
    addToCart(product) {
      console.log(product);
      vueSideCart.addItem(product.variantId, 1, {
        _imgUrl: product.images[0].src,
        _saleStatus: 'Current',
      });
      //delay enabling refresh button for 1 second
      setTimeout(() => {
        this.closeSlide();
      }, 1500);
    },

    // get ab test sections data from access api
    getABTestSectionsData() {
      // get tab content through API call
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';

      axios
        .get(
          targetdomain +
            `/section/abTestSectionsByShopifyProductId/${this.productId}`
        )
        .then((response) => {
          const sectionsData = response.data;
          //console.log(sectionsData);
          // set whyYoullLoveIt and accordion data
          if (sectionsData.whyYoullLoveIt) {
            this.whyYoullLoveIt = sectionsData.whyYoullLoveIt[this.abVersion];
            //console.log(this.whyYoullLoveIt);
          }
          if (sectionsData.detailAccordion) {
            // hardcode version to be 'a' per ecomm team
            // dynamic version commented out below in case we switch back later
            this.accordionContent = sectionsData.detailAccordion['a'];
            //console.log(this.accordionContent);
            // this.accordionContent = sectionsData.detailAccordion[this.abVersion]
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //activate the accordion drawer
    activateAccordion(drawer) {
      // if this drawer is already open, close it
      if (this.activeDrawer === drawer) {
        this.activeDrawer = null;
      } else {
        // otherwise, open the drawer
        this.activeDrawer = drawer;
      }
    },
    initEventEmitter() {
      function EventEmitter() {
        this.events = {};
      }
      EventEmitter.prototype.on = function (eventName, callback) {
        if (!this.events[eventName]) {
          this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
      };
      EventEmitter.prototype.emit = function (eventName, data) {
        if (this.events[eventName]) {
          this.events[eventName].forEach((callback) => {
            callback(data);
          });
        }
      };
      this.eventEmitter = new EventEmitter();
    },
    emitRequestComplete() {
      // Emit the event
      this.eventEmitter.emit('requestComplete', this.cart);
    },
  },
  beforeMount() {
    this.getABTestSectionsData();
  },
  mounted() {
    this.initEventEmitter();
    //console.log(this.getABTestSectionsData());
    //mounted ensures dom is ready, so we can attach to the cart icon
    // document.querySelector('.cart').addEventListener('click', function () {
    //   vueSideCart.openCart();
    // });
  },
};
